import React, { useState, Fragment, useEffect } from "react";
import { Badge } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { CurrentTimePicker } from '../jsx/components/Forms/Pickers/TimePicker';
import "bootstrap-daterangepicker/daterangepicker.css";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { Last } from "react-bootstrap/esm/PageItem";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
 import swal from 'sweetalert';
import Select from "react-select";

const OrderCheckout = () => {
  const [listItem, setlistItem] = React.useState([])
  const navigate = useNavigate();
  const [errors, setErrors] = useState('')
  const [errors1, setErrors1] = useState('')
  const [errors2, setErrors2] = useState('')
  const [errors3, setErrors3] = useState('')

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const receivedDataArray = JSON.parse(searchParams.get('data')) || [];
  let receivedItemId = searchParams.get('id') || '';
   const receivedname= searchParams.get('cname') || '';
   const [finaltotal, setfinaltotal] = useState(0)
   const [currentDate, setCurrentDate] = useState(new Date());
   const formatDate = (date) => {
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  
  };
  const notifyTopRight = () => {
    toast.success("✔️ تمت عملية الحفظ بنجاح", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  }; 
  // const receivedData = location.state?.data || [];
  // console.log(receivedData)  
  console.log('receivedDataArray',receivedDataArray)
  //  DeliveryID 	OrderID 	DeliveryPersonID 	DeliveryDate 	DelPrice 	Address 	Status 	UserID 
  const [OrderDate, setOrderDate] = useState(new Date());
  const [Discount, setDiscount] = useState('');

  // Format the date to 'YYYY-MM-DD'
  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
  const [order, setOrder] = useState({
    //  OrderID:'',
    CustomerID: receivedItemId,
    OrderDate: formatDate(currentDate),
    TotalAmount: finaltotal,
    DiscountAmount: '',
    Status: 'قيد الانتظار',
    UserID: userid,
    // DeliveryID: '',
    DeliveryPersonID: '',
    DeliveryDate: '',
    DeliveryTime: '',
    DelPrice: '',
    Address: '',
    GuaranteeTypesID: '4',
    Paystatus:'',
    Prepay:'',
  DecoratePrice:'',
  tabaknumber:'',
  tabakprice:'',
  PassportName:'',
  GuaranteeAmount:'',OrderNotes:'لا توجد',
  });

  const [lastorder, setlastorder] = useState(0)
  const [lastdip, setlastdip] = useState(0)

  const [isSaving, setIsSaving] = useState(false);
  const [orderItem1, setOrderItem1] = useState()
  const [orderItems, setOrderItems] = useState([]);
  const [total1, setTotal1] = useState(0)
  const [total, setTotal] = useState(0)
  const [address, setAddress] = useState([])
  const [delprice, setdelprice] = useState(0)
  const [dprice, setdprice] = useState(0)
  const [number, setnumber] = useState(0)
  const [checkdata, setcheckdata] = useState([]);
  const [checkdate, setcheckdate] = useState([]);
 
  const [GuaranteeAmountdisplay, setGuaranteeAmountdisplay] = useState(true);
   const [Guaranteedisplay, setGuaranteedisplay] = useState(true);


  useEffect(() => {
    checkfunc();
    const disableBack = (e) => {
      e.preventDefault();
      window.history.forward();
    };

    // Disable the back button
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', disableBack);

    getchalls();
    getGuaranteeType();
    getEmp();
   //getLastorder();
    const newOrderItems = receivedDataArray.map((item, index) => ({
      ItemID: item.ItemID,
      OrderID: '',
      ItemName: item.ItemName,
      TItemID: item.TItemID,
      UserID: userid,
      Quantity: item.Quantity,
      ItemPrice: item.ItemPrice,
      total: item.aa,
      name:receivedname,
      FoodCategoryID:item.FoodCategoryID
      //TotalAmount:finaltotal,
      
    }));
    setOrderItems(newOrderItems);
    const totalAA = newOrderItems.reduce((total, item) => total + item.total, 0);
    setTotal1(totalAA);
    const length = orderItems.length
    setOrderItem1(length)
setfinaltotal(totalAA)
setOrder((prevData) => ({
  ...prevData,
 TotalAmount : totalAA,
}));
    // const intervalId = setInterval(() => {
    //   setOrderDate(new Date());
    //  }, 1000); // Update every 1000 milliseconds (1 second)

    // Cleanup function to clear the interval when the component unmounts
    //  return () => clearInterval(intervalId);
    return () => {
      // Clean up the event listener
      window.removeEventListener('popstate', disableBack);
    };
  }, [lastorder], [orderItems])
  //const [cusnmae, setcusnmae] = useState('')
  
  const getLastorder = () => {
    try {
      axios.get('https://suhba.education.com.ly/back/api/getLastorder')
        .then(({ data }) => {
          setlastorder(data.Lastorder.OrderID);
          //setcusnmae(data.custname.CustomerName);

          console.log("la", lastorder)
        })
    } catch (error) {
      console.error('Error fetching last customer:', error);
    }
  }
  
  console.log('order items pefor store', order)

  const createintitem = async (e) => {
    e.preventDefault();
     // Check if isRadioChecked5 is true
    if (isRadioChecked5 === true && order.DecoratePrice === '') {
        swal('الرجاء ادخال سعر التزين');
        return; // Stop further execution if condition is met
    }

    // Check if GuaranteeAmount is empty when GuaranteeTypesID is '3'
    let guaranteeCheckFailed = false;
        if (order.GuaranteeTypesID == '3' && order.GuaranteeAmount === '') {
            swal('الرجاء ادخال قيمة الضمان');
            guaranteeCheckFailed = true;
        }
    if (order.GuaranteeTypesID == '1' && order.PassportName === '') {
            swal('الرجاء ادخال اسم صاحب الجواز  ');
            guaranteeCheckFailed = true;
        }
    if (guaranteeCheckFailed) {
        return; // Stop further execution if condition is met
    }

    // Check if isRadioChecked1 is false
    if (isRadioChecked1 === false) {
      if (order.DelPrice === '') {
          swal('الرجاء ادخال سعر التوصيل');
          return; // Stop further execution if condition is met
      }
      if (order.Address === '') {
          swal('الرجاء ادخال عنوان التوصيل');
          return; // Stop further execution if condition is met
      }
     if (order.DeliveryPersonID === '') {
       swal('الرجاء ادخال مندوب التوصيل');
         return; // Stop further execution if condition is met
     }
  }

  //   if (order.Prepay === '') {
  //     swal('الرجاء ادخال  العربون');
  //     return; // Stop further execution if condition is met
  // }

    console.log('order before store', order);
    const payload = {
        order,
        orderItems
    };

    if (isSaving) return;

    setIsSaving(true);

    try {
      const response = await axios.post('https://suhba.education.com.ly/back/api/new_orders', payload);
      const data = response.data;

      if (!data?.Lastorder?.OrderID) {
        toast.warning("لم يتم إنشاء الطلب. الرجاء المحاولة مرة أخرى.");
        return;
      }

      // if (!data?.Deposit?.reference_number) {
      //   toast.warning("تم إنشاء الطلب بدون رقم الإيداع.");
      // }

      setlastorder(data.Lastorder.OrderID);
   //   setlastdip(data.Deposit.reference_number);

      const SecqueryString = new URLSearchParams({
        data: JSON.stringify(orderItems),
        id: receivedItemId.toString(),
        name: receivedname,
        //RefNmber: data.Deposit.reference_number,
        DiscountAmount: Discount.toString(),
        lastorder: data.Lastorder.OrderID,
        allinfo: JSON.stringify(data.Lastorder),
        TotalAmount: finaltotal,
      }).toString();

      toast.success("تم إنشاء الطلب بنجاح!");

      setTimeout(() => {
        navigate(`/Invoice?${SecqueryString}`);
      }, 1500);

    } catch (error) {
      if (error.response) {
        toast.error(`فشل في إنشاء الطلب: ${error.response.data.message || 'خطأ غير معروف'}`);
        console.error(error.response.data);
      } else if (error.request) {
        toast.error("لا يوجد استجابة من السيرفر. تأكد من الاتصال بالإنترنت.");
        console.error(error.request);
      } else {
        toast.error("حدث خطأ أثناء إعداد الطلب.");
        console.error(error.message);
      }
    } finally {
      setOrder([])
     // setIsSaving(false);
    }
  
    // try {
    //     await axios.post('https://suhba.education.com.ly/back/api/new_orders', payload) .then(({ data }) => {
       
    //     setlastorder(data.Lastorder.OrderID);
    //     setlastdip(data.Deposit.reference_number);

    //     const SecqueryString = new URLSearchParams({
    //         data: JSON.stringify(orderItems),
    //         id: receivedItemId.toString(),
    //         name: receivedname,
    //         RefNmber: data.Deposit.reference_number,
    //         DiscountAmount: Discount.toString(),
    //         lastorder: data.Lastorder.OrderID,
    //         allinfo: JSON.stringify(data.Lastorder),

    //         TotalAmount: finaltotal,
    //     }).toString();
    //     console.log("SecqueryString", SecqueryString);
    //     notifyTopRight();

    //     setTimeout( function(){
          
    //       navigate(`/Invoice?${SecqueryString}`);

          
    //     },1500);     
    //   })
    //  } catch (error) {
    //     if (error.response) {
    //         console.log(error.response.data);
    //         console.log(error.response.status);
    //         console.log(error.response.headers);
    //     } else if (error.request) {
    //         console.log(error.request);
    //     } else {
    //         console.log('Error', error.message);
    //     }
    //     console.log(error.config);
    // }

    console.log('orderItems before store', orderItems);
};

  const clearfun = () => {
     receivedItemId=0;
     navigate('/dashboard_1')
    }
  console.log("la", lastorder)

 /* const SecqueryString = new URLSearchParams({
    data: JSON.stringify(receivedDataArray),
    id: receivedItemId.toString(),
    DiscountAmount: Discount.toString(),
    lastorder:lastorder,
  }).toString();*/
  const [isRadioChecked5, setIsRadioChecked5] = useState(false);
  const InputChange1 = (e) => {
    const { value } = e.target;
    setErrors2('')
    if (value != '')
   {  
       if (/^\d*$/.test(value)) {
       setIsRadioChecked5(true);
    setnumber(value)
    
  }else {
    setErrors2("هده الخانه لاتقبل حروف")

  }

   }
  else{
    
    const inputElement5 = document.getElementById('myinput5');
    inputElement5.value = '';
    setdprice(0)
      
      const sum = total1 +0;  
      setfinaltotal(sum)
      setOrder((prevData) => ({
        ...prevData,
       TotalAmount : sum,
      }));
     
    setIsRadioChecked5(false);}
    setErrors2("ادخل السعر")

   }

   const checkfunc = async () => {
    await axios.get('https://suhba.education.com.ly/back/api/checkfunc').then(({ data }) => {
       setcheckdate(data.offdates) 

    setcheckdata(data.result) 
    console.log(data);})

   
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
  }
const handleInputChange1 = (e) => {
  setErrors2('');
  setErrors3('');

  const { name, value } = e.target;
  console.log("val:", value);
  console.log("na:", name);

  // قائمة الحقول التي يتم التعامل معها بشكل خاص
  const handledFields = [
    'DeliveryDate',
    'GuaranteeTypesID',
    'GuaranteeAmount',
    'DecoratePrice',
    'DelPrice',
    'HallID'
  ];

  if (name === 'DeliveryDate') {
  const filteredArrayAa = checkdata.find(item => item.DeliveryDate === value);
  const filteredArrayA = checkdate.find(item => item.OffDate === value);

  if (filteredArrayA) {
    if (filteredArrayA.status === 1) {
      swal(`هذا التاريخ مقفل بسبب ${filteredArrayA.TypeName}`);
      return;
    }

    const totalQuantity = orderItems.reduce((total, item) => total + Number(item.Quantity || 0), 0);
    const existingQuantity = parseInt(filteredArrayAa?.TotalQuantity || 0, 10);
    const limit = parseInt(filteredArrayA.limitOrder, 10);

    if ((totalQuantity + existingQuantity) > limit) {
      swal(`لقد تجاوزت الحد المسموح (${limit}) لطلبيات هذا التاريخ`);
      return;
    }
  }

  // ✅ If all checks pass, update the order state
  setOrder(prevData => ({
    ...prevData,
    [name]: value,
  }));
}


  if (name === 'GuaranteeTypesID') {
 if(value == 3)
    {  setGuaranteeAmountdisplay(false)}
    else{ 
      setGuaranteeAmountdisplay(true)
    }
    if(value == 1)
    {  setGuaranteedisplay(false)}
    else{ 
      setGuaranteedisplay(true)
    }
setOrder(prevData => ({
        ...prevData,
        [name]: value,
      }));
      return;
  }

  if (name === 'GuaranteeAmount') {
    if (value === '') {
      setErrors1("يجب إدخال قيمة الضمان");
    } else if (/^\d+$/.test(value)) {
      setOrder(prevData => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setErrors1("هذه الخانة لا تقبل إلا الأعداد الصحيحة");
    }
    return; // لا نكمل تحديث عام بعد التحقق من الحقول الخاصة
  }

  if (name === 'DecoratePrice') {
    const isFloat = /^-?\d+(\.\d+)?$/;
    if (isFloat.test(value)) {
      setdprice(number * value);
      const sum = Number(total1) +  Number(delprice)  + (Number(number) * Number(value)) - Number(total);
setOrder(prevData => ({
        ...prevData,
        tabaknumber: number,
 tabakprice:  value
    }));
      setfinaltotal(sum);
      setOrder(prevData => ({
        ...prevData,
        TotalAmount: sum,
        [name]: (number * value),
      }));
      setIsRadioChecked5(true);
    } else {
      setErrors2("هذه الخانة لا تقبل إلا الأعداد الصحيحة");
    }
    return;
  }

  if (name === 'DelPrice') {
    if (/^\d+$/.test(value)) {
      const delPriceInt = parseInt(value, 10);
      setdelprice(delPriceInt);
      const sum = Number(total1) + Number(dprice) + delPriceInt - Number(total);

      setfinaltotal(sum);
      setOrder(prevData => ({
        ...prevData,
        TotalAmount: sum,
        [name]: delPriceInt,
      }));
    } else {
      setErrors3("هذه الخانة لا تقبل حروف");
    }
    return;
  }

  if (name === 'HallID') {
    const matchingHall = halls.find(item => value == item.HallID);

    if (matchingHall) {
      const hallPrice = parseInt(matchingHall.ItemPrice, 10);
      setOrder(prevData => ({
        ...prevData,
        Address: matchingHall.HallAddress,
      }));
      setAddress(matchingHall.HallAddress);
      setdelprice(hallPrice);

      if (total === 0) {
        const sum = Number(total1) + Number(dprice) + hallPrice - Number(total);
        setfinaltotal(sum);
        setOrder(prevData => ({
          ...prevData,
          TotalAmount: sum,
          DelPrice:hallPrice
        }));
      }
    }
    setOrder(prevData => ({
      ...prevData,
      [name]: value,
    }));
    return;
  }

  // ✅ تحديث عام فقط إذا لم يتم التعامل مع هذا الحقل بشكل خاص
  if (!handledFields.includes(name)) {
    setOrder(prevData => ({
      ...prevData,
      [name]: value,
    }));
  }
};


  const handleInputChange2 = (e) => {
    const input = e.target.value;

    // Check if the input is a number or an empty string
    if (/^\d*$/.test(input)) {
      setDiscount(input);
       
        setTotal(input);
        const sum =  
        Number(total1) +
          Number(delprice) + 
        Number(dprice) -
        Number(input);
        setfinaltotal(sum)
        setOrder((prevData) => ({
          ...prevData,
          TotalAmount:sum ,
           DiscountAmount: input,
        }));
     
     
      console.log('t', total1)
        


    } else {
      setErrors("هده الخانه لاتقبل الا الاعداد الصحيحة")

    }
    setErrors('')
    setErrors1('')
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOrder((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  // Assuming you have an array of items you want to add
  console.log(total1)
  // Use a loop to add items to orderItems



  const [emp, setEmp] = useState([]);
  const [guaranteeType, setGuaranteeType] = useState([]);
  const [halls, setHalls] = useState([]);
  
  const getEmp = async () => {
    await axios.get('https://suhba.education.com.ly/back/api/getEmp').then(({ data }) => { setEmp(data) })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      });

  }
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');

  const userPermissions = JSON.parse(userPermissionsJSON);
  // Function to search for permissions for a specific page
  function getActionsForPage(pageName) {
    // Find the permissions object for the given page
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);

    // If permissions for the page are found, return the actions
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1')

      return [];
    }
  }

  // Usage
  const pageName = 'Orders';
  const actionsForPage = getActionsForPage(pageName);
  const [isRadioChecked1, setIsRadioChecked1] = useState(true);
  const [isRadioChecked2, setIsRadioChecked2] = useState(true);
  const [isRadioChecked4, setIsRadioChecked4] = useState(true);
  const [isRadioChecked8, setIsRadioChecked8] = useState(true);

  const [isRadioChecked, setIsRadioChecked] = useState(true);
  const handleInputChange4 = () => {
    setIsRadioChecked4(!isRadioChecked4);


  }
  const handleInputChange8 = () => {
    setIsRadioChecked8(!isRadioChecked8);

  }
  const handleRadioChange1 = () => {
    setIsRadioChecked1(false);
    const inputElement3 = document.getElementById('myinput3');
    inputElement3.value = '';
    setIsRadioChecked2(true);
    setIsRadioChecked(false);
    setAddress('')
    const inputElement1 = document.getElementById('myinput1');
    inputElement1.value = '';
    ///const inputElement = document.getElementById('myInput');
    // inputElement.value = '';
  };
  const handleRadioChange = () => {
    const inputElement = document.getElementById('myinput');
    inputElement.value = '';
    const inputElement1 = document.getElementById('myinput1');
    inputElement1.value = '';
    const inputElement2 = document.getElementById('myinput2');
    inputElement2.value = '';

    setIsRadioChecked(true);
    setIsRadioChecked2(true);
    setIsRadioChecked1(true)
  };
  const handleRadioChange2 = () => {
    const inputElement2 = document.getElementById('myinput2');
    inputElement2.value = '';
    setIsRadioChecked(false);
    setIsRadioChecked2(false);
    setIsRadioChecked1(true)
  };
  const queryString = new URLSearchParams({
    data: receivedDataArray,
    id: receivedItemId,
    //total:total,

  }).toString();
  const getGuaranteeType = async () => {
    await axios.get('https://suhba.education.com.ly/back/api/getGuaranteeType ').then(({ data }) => { setGuaranteeType(data.GuaranteeType) })
  }
  const getchalls = async () => {
    await axios.get('https://suhba.education.com.ly/back/api/getchalls ').then(({ data }) => { 
      setHalls(data.HallName)
    
    })
  }
  const hallOptions = halls.map((row) => ({
  value: row.HallID,
  label: row.HallName
}));
  useEffect(() => {
    const handleEnterKey = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const form = e.target.form;
        const fields = Array.from(form.elements).filter(el => (
          (el.tagName === 'INPUT' && !el.disabled) ||
          (el.tagName === 'TEXTAREA' && !el.disabled) ||
          (el.tagName === 'SELECT' && !el.disabled)
        ));      const currentFieldIndex = fields.findIndex(el => el === document.activeElement);
        const nextFieldIndex = currentFieldIndex + 1;
        if (nextFieldIndex < fields.length) {
          fields[nextFieldIndex].focus();
        }
      }
    };
    
    document.addEventListener('keydown', handleEnterKey);
    
    return () => {
      document.removeEventListener('keydown', handleEnterKey);
    };
  }, []);
   
  console.log('order order', orderItems)
  return (

    <Fragment>
      		<ToastContainer />

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4 order-md-2 mb-4">
                    <h4 className="d-flex justify-content-between align-items-center mb-3">
                      <span className="text-muted">محتويات السلة</span>
                      <Badge as="a" href="" bg="primary badge-circle">
                        <i className="fa fa-shopping-basket me-2"></i> {orderItem1}
                      </Badge>
                      <span className="badge badge-primary badge-pill">

                      </span>
                      {/*<Link to={`/Orders?${SecqueryString}`} className="btn btn-primary">السابق</Link>*/}

                    </h4>
                    <div className="card">

                      <div className="card-body p-0">
                        <div className="table-responsive active-projects dlab-scroll" style={{ height: "200px" }}>
                          <table id="projects-tbl4" className="table">
                            <thead>
                              <tr>
                                <th>اسم الصنف</th>
                                <th>الكمية</th>
                                <th>السعر</th>
                               </tr>
                            </thead>
                            <tbody>
                              {receivedDataArray.map((item, ind) => (
                                <tr key={ind} hover>
                                  <td>{item.ItemName}
                                  </td>


                                  <td>{item.Quantity}</td>
                                  <td>{item.aa}د</td>
 
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div className="input-group" style={{ direction: "ltr" }}>
                          <input type="text" style={{ direction: "rtl" }}
                            defaultValue={Discount}
                            onBlur={handleInputChange2}
                            name="DiscountAmount"
                            
                            className="form-control" ></input>

                          <button type="" className="input-group-text">التخفيض</button>
                        </div>
                        {errors ? <div className=' alert alert-danger'>{errors}</div> : ""}

                        <table className="table table-clear">
                          <tbody>
                            <tr>
                              <td className="left">
                                <strong>الحسابى الكلي</strong>
                              </td>
                              <td className="right">{total1}د</td>
                            </tr>
                            <tr>
                              <td className="left">
                                <strong>الحسابى بعد تخفيض{' '}{Discount}د</strong>
                              </td>
                              <td className="right">{total}د</td>
                            </tr>
                            <tr>
                              <td className="left">
                                <strong>خدمة توصيل</strong>
                              </td>
                              <td className="right">{delprice}د</td>
                            </tr>
                            <tr>
                              <td className="left">
                                <strong>خدمة التزين  </strong>
                              </td>
                              <td className="right">{dprice}د</td>
                            </tr>
                            <tr>
                              <td className="left">
                                <strong>الحسابى النهائي</strong>
                              </td>
                              <td className="right">
                                <strong>{finaltotal}د</strong>
                                <br />
                              </td>
                            </tr>
                          </tbody>
                        </table>


                      </div>
                    </div>

                  </div>
                  <div className="col-md-8 order-md-1">
                    <h4 className="mb-3">طلبية جديدة</h4>
                    <form onSubmit={createintitem}  autocomplete="off">
                      <div style={{ height: "400px" }}>

                        <div className="row">
                           
                          <div className="col-xl-6 mb-4">
                            <div className="row">
                              <div className="col-xl-4 mb-1">
                                <label htmlFor="exampleFormControlInput99" className="form-label" > تاريخ  الاستلام  <span className="text-danger">*</span></label>
                              </div><div className="col-xl-8 mb-1">
                                <input required 
                                  type="date"
                                  className="form-control ms-3 " style={{ float: "right" }}
                                  id="same-address" Name="DeliveryDate"

                                  defaultValue={order.DeliveryDate} onChange={handleInputChange1}
                                />
                              </div></div></div>
                              <div className="picker-data col-xl-6 mb-4">
                            <div className="color-time-picker">
                              <div className="row">
                                <div className="col-xl-4 mb-1">
                                  <label htmlFor="exampleFormControlInput99" className="color-time-picker" > توقيت الطلبية  <span className="text-danger">*</span></label>
                                </div>
                                <div className="col-xl-8 mb-1 " style={{ direction: "ltr" }}>
                                  <input required
                                    type="time"
                                    className="form-control ms-3 " style={{ float: "right" }}
                                    id="same-address"
                                    Name="DeliveryTime"
                                    defaultValue={order.DeliveryTime} onChange={handleInputChange1}
                                  /></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-12 mb-4">

                            <div className="row">
                              <div className="col-xl-2 mb-1">
                                <label className="form-label">نوع الضمان</label>

                              </div>

                              <div className="col-xl-4 mb-1">
    <select
        className="default-select form-control"
        name="GuaranteeTypesID"
        value={order.GuaranteeTypesID || ""} // Ensure controlled component
        onChange={handleInputChange1}
    >
        <option value="" disabled>Select</option>
        {guaranteeType.map((row) => (
            <option key={row.GuaranteeTypesID} value={row.GuaranteeTypesID}>
                {row.GuaranteeTypesName}
            </option>
        ))}
    </select>
</div>

                              <div className="col-xl-2 mb-1">
                                <label className="form-label"   hidden={Guaranteedisplay}>  اسم صاحب الجواز</label>

                              </div>
                                      <div className="col-xl-4 mb-1">

                                        <input type="text" placeholder="الاسم"
                                        hidden={Guaranteedisplay} id="myinput3" className="form-control" name="PassportName" defaultValue={order.PassportName} onChange={handleInputChange1} />
 
                                      </div>
                              <div className="col-xl-2 mb-1">
                                <label className="form-label"   hidden={GuaranteeAmountdisplay}>القيمة المالية</label>

                              </div>
                                      <div className="col-xl-4 mb-1">

                                        <input type="text" placeholder="القيمة"
                                        hidden={GuaranteeAmountdisplay} id="myinput3" className="form-control" name="GuaranteeAmount" defaultValue={order.GuaranteeAmount} onChange={handleInputChange1} />
                                                              {errors1 ? <div className=' alert alert-danger'>{errors1}</div> : ""}

                                      </div>
                            </div>
                          </div>
                         
                        </div>
                        <div className="row">
                          <div className="col-xl-12 ">

                            <fieldset className="form-group">
                              <div className="row ">

                                <div className="col-sm-3">
                                  <div className="form-check mb-4">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="gridRadios"
                                      value="option1"
                                      onChange={handleRadioChange}
                                      defaultChecked
                                    />
                                    <label className="form-check-label">
                                      الاستلام من المحل
                                    </label>
                                  </div> </div>
                                <div className="col-sm-3">

                                  <div className="form-check mb-4">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="gridRadios"
                                      value="option2"

                                      onChange={handleRadioChange2} />

                                    <label className="form-check-label">
                                       من الصالة
                                    </label>
                                  </div>

                                </div>
                                <div className="col-sm-3">



                                <div className="form-check mb-4">

                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="gridRadios"
                                          value="option2"

                                          onChange={handleRadioChange1} />

                                        <label className="form-check-label">
                                          الى العنوان </label>
                                          </div> </div>
                                      <div className="col-xl-1  mb-4">
                                       <div className="row" style={{display:'flex'}}> 
                                       <label hidden={isRadioChecked1} القيمة className="form-check-label">
                                   السعر</label></div> </div>
                                       <div className="col-xl-2  ">

                                          <input  type="text" hidden={isRadioChecked1} id="myinput3" className="form-control" name="DelPrice" defaultValue={order.DelPrice} onChange={handleInputChange1} />
                                          {errors3 ? <div className=' alert alert-danger'>{errors3}</div> : ""}

                                      </div> 


                               
                              </div>
                            </fieldset>
                          </div>

                        </div>
                        <div className="row">

                          <div className=" col-xl-12 mb-4">
                            <div className="row">
                              <div className="col-xl-2 mb-1">

                                <label className="form-label " htmlFor="address">العنوان</label>
                              </div>
                              <div className="col-xl-4 mb-1">

                                <input type="text"  disabled={isRadioChecked1} className="form-control" id="myinput2" name="Address" defaultValue={order.Address} onChange={handleInputChange1} />
                              </div>
                              <div className="col-xl-2 mb-1">
                                <label className="form-label ">المندوب</label>

                              </div>
                              <div className="col-xl-4 mb-1">

                                <select   className="default-select form-control" id="myinput" disabled={isRadioChecked} name="DeliveryPersonID" defaultValue={order.EmployeeID} onChange={handleInputChange1}>
                                  <option data-display="Select">اختر من القائمة</option>
                                  {
                                    emp.map((row) => (
                                      <option key={row.EmployeeID} value={row.EmployeeID}>
                                        {row.FirstName}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>


                          </div>

                        </div>





                        <div className="row">
                          <div className="col-xl-12 mb-4">
                            <div className="row">

                              <div className="col-xl-2 mb-1">
                                <label className="form-label ">قاعة الافراح</label>

                              </div>
                              {/* <div className="col-xl-4 mb-1">

                                <select className="default-select form-control " disabled={isRadioChecked2}
                                  onChange={handleInputChange1} id="myinput1" name="HallID" >
                                  <option data-display="Select">اختر من القائمة</option>
                                  {
                                    halls.map((row) => (
                                      <option key={row.HallID} value={row.HallID}>
                                        {row.HallName}
                                      </option>
                                    ))}
                                </select>   </div> */}
                                <div className="col-xl-4 mb-1">

  <Select 
     isDisabled={isRadioChecked2}
    options={hallOptions}
    onChange={(selected) =>
      handleInputChange1({
        target: {
          name: "HallID",
          value: selected?.value
        }
      })
    }
    placeholder="اختر من القائمة"
    isSearchable={true}
  />

</div>
                              <div className="col-xl-2">
                                <label htmlFor="state">عنوانها</label>
                              </div>
                              <div className="col-xl-4 mb-1">

                                <label className="form-label "> {address} </label>


                              </div>
                            </div>
                          </div>
                        </div>
                    
                  
                      <fieldset className="form-group">
                      <div className="row ">
                       
                       
                        <div className="col-sm-6">



<div className="">
<div className="row">
    <div className="col-xl-4 mb-4">
  <input
    className="form-check-input"
    type="checkbox"
    name="gridRadios"
    value="option2"
 
  onChange={handleInputChange4}                            />

  <label className="form-check-label me-2">
  تزين الصحن </label></div>
<div className="col-xl-8 mb-4">
<div className="row">

<div className="col-xl-2 mb-1">

<label hidden={isRadioChecked4} className="form-check-label">
لعدد</label></div>
<div className="col-xl-4 mb-1">

<input type="text"
 hidden={isRadioChecked4} id="myinput4" className="form-control" name="DecoratePrice"  onChange={InputChange1}   />
</div>
<div className="col-xl-2 mb-1">

<label hidden={isRadioChecked4} disabled={!isRadioChecked4} className="form-check-label">
بسعر</label></div>
<div className="col-xl-4 mb-1">

<input  type="text"disabled={!isRadioChecked5}  hidden={isRadioChecked4} id="myinput5" className="form-control" name="DecoratePrice" defaultValue={order.DecoratePrice} onChange={handleInputChange1}  />
</div>
</div></div>
{errors2 ? <div className=' alert alert-danger'>{errors2}</div> : ""}

</div>
</div>

</div>
                      </div>
                    </fieldset>
                    <div className="row">

                    <div className="col-xl-12 mb-4">
                              <div className="row">
          {/* <div className="col-xl-2 mb-1">
        <label htmlFor="exampleFormControlInput99" className="form-label" >العربون <span className="text-danger">*</span></label>                                    
        </div><div className="col-xl-4 mb-1">
        <input
                                       type="text"
                                       className="form-control ms-3 " style={{float: "right"}}
                                       id="same-address"    Name="Prepay"
          

                                       defaultValue={order.Prepay} onChange={handleInputChange1}
                                    />
        </div> */}
       <div className="col-xl-2 mb-1">
        <label htmlFor="exampleFormControlInput99" className="form-label" >ملاحظات <span className="text-danger"></span></label>                                    
        </div><div className="col-xl-4 mb-1">
        <textarea className="form-control ms-3 " id="exampleFormControlTextarea1" rows="3"
          defaultValue={order.OrderNotes} onChange={handleInputChange1}Name="OrderNotes"

                                        ></textarea>
       
     
        </div> 
        
        
        </div>
        </div>
  </div>    </div>
                      <hr className="mb-4" />


                      <button
  className="btn btn-primary btn-sm m-1"
  type="submit"
  disabled={isSaving}
>
  {isSaving ? 'جاري الحفظ...' : 'التالي'}
</button>
                      <button
                        className="btn btn-secondary btn-sm m-1"
                       type="submit" onClick={clearfun}>

                        الغاء
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OrderCheckout;
